module.exports = __webpack_public_path__ + "img/store2.38084b8a.jpg";